<template>
  <div id="project" class="project__edit__wrapper">
    <HeaderControlsProject :myWeek='false' @filterUpdated='false' @collapseToggleUpdated='false' />
    <div class="container-fluid project--details">
      <ProjectDeliverableList/>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import HeaderControlsProject from "../components/common/HeaderControlsProject";
import ProjectDeliverableList from "../components/deliverables/ProjectDeliverableList";

export default {
  data() {
    return {}
  },
  components: {
    ...mapGetters([
      'projectDeliverables'
    ]),
    HeaderControlsProject,
    ProjectDeliverableList
  },
};
</script>
